import React from 'react';
import ScrollContainer from 'components/ScrollContainer';
import PolicyBaseTable from '../PolicyBaseTable';
import styles from './styles.module.scss';

const AdditionalProfitTable = ({
    rows,
}) => (
    <ScrollContainer>
        <PolicyBaseTable
            rows={rows}
            className={styles.AdditionalProfitTable}
        />
    </ScrollContainer>
);

export default AdditionalProfitTable;
